export function validateEmail(email: string): boolean {
  const pattern = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
  email = email.replace(' ', '');

  if (email.length === 0) {
    return false;
  }

  return pattern.test(email);
}
